/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { reportsOverviewPageEntryPoint as reportsOverviewPageEntry } from '@jira/software__reports-overview-page/src/reportsOverviewPageEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { softwareReportsOverviewBoardlessRoute } from '@jira/router-routes__classic-projects-routes/src/softwareReportsOverviewBoardlessRoute.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { staticSidebarJSWReportsResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-jsw-reports-sidebar/index.tsx';
import { classicSoftwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import { ReportsOverviewSkeleton } from '@jira/platform__skeletons/src/ui/reports-overview/ReportsOverviewSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';

const reportsOverviewPageEntryPoint = createPageEntryPoint({
	main: reportsOverviewPageEntry,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const softwareReportsOverviewBoardlessRouteEntry: Route = createEntry(
	softwareReportsOverviewBoardlessRoute,
	() => ({
		group: 'software-reports-boardless',
		skeleton: ReportsOverviewSkeleton,

		entryPoint() {
			return reportsOverviewPageEntryPoint;
		},

		layout: classicSoftwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: [
			...getNavigationResources(),
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarJSWReportsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
		],

		ufoName: 'reports-overview',
		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
